<div class="clearfix">
	<div class="float-left">
		<h1 class="page-title">
			{{ id === 0 ? 'Create' : 'Edit' }} User
			<!-- Display the user name if we have a first name value -->
			<span *ngIf="formGroup.value.fullName">- {{ formGroup.value.fullName }}</span>
		</h1>
	</div>
</div>
<hr class="page-title">

<ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="activeTab">
	<li ngbNavItem="Details">
		<a ngbNavLink>Details</a>
		<ng-template ngbNavContent>
			<form pcgSubmitUrl="api/Administration/Users/SaveUser" (messageReceive)="saveUser($event)" [formGroup]="formGroup">
				<div>
					<input type="hidden" formControlName="userId" />
					<input *ngIf="id === 0" type="hidden" formControlName="isActive" />
					<input *ngIf="id !== 0" type="hidden" formControlName="userName" />
					<input *ngIf="id !== 0" type="hidden" formControlName="permissionId" />
	
					<div class="row">
						<div id="activation" class="col-md-12">
							<div *ngIf="isLockedOut" id="divUnlockUser">
								<fa-icon [icon]="faIconName.faUnlock" 
									class="unlockIcon fa-lg" 
									(click)="unlockUser()" 
									ngbTooltip="This user is locked out. Click here to unlock the user and send them an email with login instructions."
								></fa-icon>	
							</div>
							<div *ngIf="!isCurrentUser" class="activate">
								<p [class.text-danger]="!model.isActive" [class.d-none]="model.isActive" style="white-space: nowrap;">
									This User is deactivated.
								</p>
								<button *ngIf="canChangePermissions && model.userId !== 0" 
									class="btn btn-sm" 
									[class.btn-danger]="model.isActive" 
									[class.btn-save]="!model.isActive" 
									(click)="activateDeactivate(); model.isActive = !model.isActive">
									{{ model.isActive ? 'Deactivate' : 'Reactivate' }}
								</button>
							</div>							
						</div>
					</div>
	
					<div class="row">
						<pcg-control-group class="col-md-3" label="Full Name" [validations]="fullNameValidation">
							<input pcgControlRef pcgNoSpecialChars class="form-control" type="text" formControlName="fullName" />
						</pcg-control-group>
	
						<pcg-control-group class="col-md-3" label="Email">
							<input pcgControlRef class="form-control email" type="text" formControlName="email" />
						</pcg-control-group>
	
						<pcg-control-group class="col-md-3" label="Phone">
							<input pcgPhoneExt pcgControlRef class="form-control" type="text" formControlName="phoneNumber" />
						</pcg-control-group>

						<div class="col-md-3" *ngIf="this.isAdmin">
							<pcg-control-group  label="Utility Provider">
								<pcg-select  placeholder="Select a Utility Provider" [sendFormData]="false" pcgControlRef
									dataSource="api/Select/UtilityProviders" formControlName="utilityProviderId"></pcg-select>
							</pcg-control-group>
						</div>
						<div class="col-md-3" *ngIf="!this.isAdmin">

							<label><b>Utility Provider</b></label>
							<br/>
							<span>
								{{model.utilityProviderName}}
							</span>		
						</div>	
						
						
					</div>

					<div *ngIf="id === 0" class="row">
						<pcg-control-group class="col-md-4" label="Username" [validations]="userNameValidation">
							<input pcgControlRef class="form-control" type="text" formControlName="userName" />
						</pcg-control-group>

						<pcg-control-group class="col-md-4" label="Permission">
							<pcg-select placeholder="Select an Permission" [sendFormData]="false" pcgControlRef
								dataSource="api/Select/Permissions" formControlName="permissionId" (change)="changePermissions()"></pcg-select>
						</pcg-control-group>
					</div>
	
					<div *ngIf="customFieldsCount > 0">
						<hr />
						<pcg-dynamic-form [fields]="fields" [fg]="formGroup" fgName="customFields"></pcg-dynamic-form>
						<hr />
					</div>
					
					<div class="row">
						<div *ngIf="canSeePasswordButtons" class="col-md-2 mobileFriendly">
							<input type="button" (click)="resetPassword(true)" class="btn btn-save btn-sm"
								ngbTooltip="Send user a welcome email with their username and the ability to choose a new password."
								value="Send Welcome Email" id="btnSendWelcomeMessage" />
						</div>					
					</div>
	
					<pcg-fixed-buttons>
						<a *ngIf="!isCurrentUser || canManageUsers" class="btn btn-cancel btn-lg" backButton="/administration/users">Back</a>
						<button *ngIf="id !== 0" class="btn btn-save btn-lg">Save</button>
						<button *ngIf="id === 0" class="btn btn-save btn-lg">Next</button>
					</pcg-fixed-buttons>
				</div>
			</form>				
		</ng-template>
	</li>

	<!-- 2FA -->
	<li ngbNavItem="Security" *ngIf="id !== 0">
		<a ngbNavLink>Security</a>
		<ng-template ngbNavContent>
			<form pcgSubmitUrl="api/Administration/Users/SaveUser" (messageReceive)="saveUser($event)" [formGroup]="formGroup">
				<h4>Login Information</h4>
				<br />
				<div class="row">
					<pcg-control-group class="col-md-6 col-lg-4" label="Username" [validations]="userNameValidation">
						<input pcgControlRef class="form-control" type="text" formControlName="userName" (change)="saveUsername()" />
					</pcg-control-group>
					
					<div *ngIf="canSeePasswordButtons" class="col-md-3 mx-lg-5 mx-xxl-3 col-lg-1 mobileFriendly">
						<br />
						<input type="button" (click)="resetPassword(false)" class="btn btn-save btn-md"
							ngbTooltip="Send user a reset password email with their username and the ability to choose a new password."
							value="Reset Password" id="btnResetPassword" />
					</div>
	
					<div class="col-md-3 mx-lg-5 mx-xxl-3 col-lg-1 mobileFriendly">
						<br />
						<input *ngIf="isCurrentUser" type="button" id="btnChangePassword" value="Change Password"
						(click)="openChangePasswordModal()" class="btn btn-save btn-md" />
					</div>
				</div>
				
				<hr />
				<div class="row">
					<pcg-control-group class="col-md-6 col-lg-4" label="Permission">
						<pcg-select placeholder="Select a Permission" [sendFormData]="false" pcgControlRef
							dataSource="api/Select/Permissions" formControlName="permissionId" (change)="changePermissions()"></pcg-select>
					</pcg-control-group>
					<div class="col-md-1 mx-md-0 mx-lg-5 mx-xxl-2 col-lg-1 mobileFriendly">
						<input [class.permissionInfoCurrentUser]="isCurrentUser" [class.permissionInfoNotCurrentUser]="!isCurrentUser"
							type="button" value="Permissions Info" (click)="openPermissionsInfoModal()" class="btn btn-save btn-md" />
					</div>
				</div>
			</form>		
		</ng-template>
	</li>

	<!-- Login History -->
	<li ngbNavItem="Login History" *ngIf="id !== 0">
		<a ngbNavLink>Login History</a>
		<ng-template ngbNavContent>
			<!-- This component is in the user-login-history directory under the edit-user component's directory -->
			<pcg-user-login-history [id]="id"></pcg-user-login-history>
		</ng-template>
	</li>

	<!-- Audit History -->
	<li ngbNavItem="Audit History" *ngIf="id !== 0 && canManageUsers">
		<a ngbNavLink>Audit History</a>
		<ng-template ngbNavContent>
			<pcg-shared-audit-history [id]="id" [viewModel]="viewModelString" [auditHistoryName]="auditHistoryName"></pcg-shared-audit-history>
		</ng-template>
	</li>

</ul>

<div [ngbNavOutlet]="nav"></div>
